exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes PlayText_fadeIn__19OyP {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes PlayText_fadeIn__19OyP {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes PlayText_fadeOut__2RN8c {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes PlayText_fadeOut__2RN8c {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.PlayText_playText__1H758 {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-flex: 1 1;\n          flex: 1 1; }\n  .PlayText_playText__1H758 .PlayText_logo__3Rl3P {\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center center;\n    margin: 5px;\n    width: 30px;\n    height: 30px;\n    -webkit-flex-shrink: 0;\n            flex-shrink: 0; }\n  .PlayText_playText__1H758 .PlayText_text__BVELx {\n    line-height: 1.2;\n    padding: 5px;\n    box-sizing: border-box;\n    border-left: 1px solid #fff; }\n", ""]);

// exports
exports.locals = {
	"color": "#ff3b00",
	"colorSecondary": "#4caf50",
	"colorContrastText": "#ffffff",
	"colorLight": "#ff7349",
	"colorDark": "#ce3000",
	"colorSecondaryLight": "#81c784",
	"colorSecondaryDark": "#388e3b",
	"hostColor": "#eb8315",
	"hostColorSecondary": "#f44336",
	"hostColorContrastText": "#ffffff",
	"hostColorLight": "#ffa74a",
	"hostColorDark": "#cf6a00",
	"playText": "PlayText_playText__1H758",
	"logo": "PlayText_logo__3Rl3P",
	"text": "PlayText_text__BVELx",
	"fadeIn": "PlayText_fadeIn__19OyP",
	"fadeOut": "PlayText_fadeOut__2RN8c"
};